import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import Alert from "../../components/Alert";
import { listPayslipTemplateDefaults, getCurrentPayslipTemplate, savePayslipTemplate } from "../../api/payslipTemplateApi";
import "../Users/UsersPage.css";

/**
 * digicampusbd's "Payslip Template" screen (`/payslip/template`) — picks
 * one of 2 fixed, hardcoded built-in payslip layouts ("Payslip Template-1" /
 * Three Column, "Payslip Template-2" / Four Column) for this institute's
 * pay-in slips. Not a real template *editor* — same as the old app, the
 * dropdown only ever offers those 2 fixed choices.
 */
export default function PayslipTemplatePage() {
  const [defaults, setDefaults] = useState([]);
  const [current, setCurrent] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const load = () => {
    setLoading(true);
    setError("");
    Promise.all([listPayslipTemplateDefaults(), getCurrentPayslipTemplate()])
      .then(([defaultList, currentTemplate]) => {
        setDefaults(defaultList);
        setCurrent(currentTemplate);
        setSelectedId(currentTemplate.templateDefaultId);
      })
      .catch(() => setError("Failed to load payslip template."))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!selectedId) {
      setError("Select a template first.");
      return;
    }
    setSaving(true);
    try {
      const saved = await savePayslipTemplate(selectedId);
      setCurrent(saved);
      setSuccess("Payslip template saved.");
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save template.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Payslip Template</h1>
      </div>
      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <form onSubmit={handleSubmit} className="user-form" style={{ maxWidth: 420 }}>
            <label>Select Payslip Template</label>
            <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
              <option value="" disabled>
                Select Template
              </option>
              {defaults.map((d) => (
                <option key={d.templateDefaultId} value={d.templateDefaultId}>
                  {d.templateName}
                </option>
              ))}
            </select>
            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </form>

          {current && (
            <div style={{ marginTop: 24 }}>
              <h3>Current Template</h3>
              <p>
                <strong>Template Name:</strong> {current.templateName}
                <br />
                <strong>Template Note:</strong> {current.templateNote}
              </p>
            </div>
          )}
        </>
      )}
    </MainLayout>
  );
}
